<template>
  <div class="horizontal-animation">
    <HorizontalOrange :animation="animation" :loop="loop"/>
  </div>
</template>

<script>
import HorizontalOrange from '@/components/HorizontalOrange.vue'

export default {
  name: 'horizontal-orange',
  props: ['animation', 'loop'],
  components: {
    HorizontalOrange
  }
}
</script>

<style lang="scss" scoped>

.horizontal-animation {
  height: 100%;
  width: 100%;
  z-index: 1;
}

</style>
